import React, {useCallback, useState} from 'react';
import {Box, Fade, Modal, Typography} from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import {global, input, sip} from "../translate";
import {useDispatch} from "react-redux";
import {sipCreateRequest, sipLocalRequest} from "../store/actions/sip";
import Account from "../helpers/Account";
import Cookies from "js-cookie";
import qs from "query-string";
import {useLocation} from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import {style,} from "../helpers/style";
import AddSipShort from "./AddSipShort";


function AddSip({open, setOpen}) {
    const [form, setForm] = useState({
        count: 1,
        isMob: 1
    })
    const location = useLocation()
    const query = qs.parse(location.search, {arrayFormat: 'comma'});
    const dispatch = useDispatch()
    const [generate, setGenerate] = useState(false);
    const handleChange = useCallback((name, ev) => {
        setForm((prevState) => ({
            ...prevState,
            [name]: ev
        }))
    }, [])
    const handleGenerate = useCallback( (ev) => {
        ev.preventDefault()
        setGenerate(true)
    }, [])
    const handleAdd = useCallback(async (ev) => {
        console.log(form)
        ev.preventDefault()
        await dispatch(sipLocalRequest(form))
        await dispatch(sipCreateRequest(form.count,[], Account.getUrsToken(), form.isMob, Cookies.get("sip") || query.limit || 10, query.page || 1, query.search || '', '', query.sortBy || '', query.sortOrder || ''))
        setOpen(false)
    }, [form, location.search])
    return (
        <>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={() => setOpen(false)}
                closeAfterTransition
                slots={{backdrop: Backdrop}}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <div className="d-flex flex-row justify-content-between">
                            <Typography id="transition-modal-title" variant="h6" component="h2">
                                {sip.add[+localStorage.getItem('atsLang') || 1]}
                            </Typography>
                            <span style={{cursor: 'pointer'}} onClick={() => setOpen(false)}>
                            <CloseIcon/>
                        </span>
                        </div>
                        <form onSubmit={handleAdd} id="transition-modal-description sip_content"
                              style={{marginTop: 20}}>
                            <div className="d-flex flex-row">
                                <button onClick={handleAdd} className="addBtnBig">
                                    {sip.add_btn[+localStorage.getItem('atsLang') || 1]}
                                </button>
                                {Cookies.get('viewer') ?
                                    <button style={{marginLeft: 20}} onClick={handleGenerate} className="addBtnBig">
                                        {sip.generate_btn[+localStorage.getItem('atsLang') || 1]}
                                    </button> : null}
                            </div>
                            {Cookies.get('viewer') ?
                                <>
                                    <div style={{margin: '20px 0'}}>
                                        <label className="count">
                            <span>
                               {global.count[+localStorage.getItem('atsLang') || 1]} :
                            </span>
                                            <input value={form.count}
                                                   onChange={(ev) => handleChange('count', ev.target.value)}
                                                   type="number"/>
                                        </label>
                                    </div>
                                    <div style={{margin: '44px 0px 20px'}}>
                                        <label className="row" style={{color: '#a7a7a7', fontSize: 13}}>
                                <span className="col-lg-6">
                                    {sip.num[+localStorage.getItem('atsLang') || 1]}
                                </span>
                                            <span className="col-lg-6">
                                    <input onChange={(ev) => handleChange('isMob', ev.target.checked ? 1 : 0)}
                                           checked={form.isMob} type="checkbox"/>
                                </span>
                                        </label>
                                    </div>
                                </>

                                : null}

                        </form>
                    </Box>
                </Fade>
            </Modal>
            {generate ? <AddSipShort setGlobalOpen={setOpen} open={generate} isMob={form.isMob} count={form.count} setOpen={setGenerate}/> : null}
        </>
    );
}

export default AddSip;
